/**
 * @module
 * @author
 * @version 1.0
 * @description [操作cookie组件]
 */

const cookie = {
    /**
      * @function set
      * @param {string}  name - Cookie名字[必选]
      * @param {string}  value - Cookie的值[必选]
      * @param {string}  domain - 设置cookie的域名，默认值：m.fenqile.com[可选]
      * @param {string}  path - 设置cookie存放的路径[可选]
      * @param {string}  minute - 设置cookie的有效期(分钟)[可选]
      * @description 添加设置cookie
      * @version 1.0
      * @instance 
      * @example
      * cookie.set('name', 'value');
      */
    set: function(name, value, domain, path, minute){
        var v = '',
            now = new Date(),
            date = new Date();

        v = name + '=' + value;

        // 设置有效期时间
        if(minute){
            date.setTime(parseFloat(+now) + 60 * 1000 * minute);
            v += '; expires=' + date.toUTCString();
        }
        
        // domain 必须与当前域名相同 否则操作失效
        v += '; domain=' + (domain || '.fenqile.com');
        v += '; path=' + (path || '/');
        v += ';';

        document.cookie = v;
    }, 
    /**
      * @function get
      * @param {string} name - Cookie名字 
      * @description cookie取值
      * @version 1.0
      * @instance
      * @returns {string} 
      * @example
      * cookie.get('name'); //return 'value'
      */
    get: function(name){
        var reg = new RegExp('(?:^|;+|\\s+)' + name + '=([^;]*)'),
            item = document.cookie.match(reg);

        return !item ? '' : item[1];
    }, 
    /**
      * @function remove
      * @param {string} name - Cookie名字  
      * @description 删除cookie
      * @version 1.0
      * @instance 
      * @example
      * cookie.remove('name');
      */
    remove: function(name, domain, path){
        this.set(name, '', domain, path, -1);
    }
}

export default cookie;